import { render } from "./shopify.vue?vue&type=template&id=22b0999b&scoped=true"
import script from "./shopify.vue?vue&type=script&lang=js"
export * from "./shopify.vue?vue&type=script&lang=js"

import "./shopify.vue?vue&type=style&index=0&id=22b0999b&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b0999b"]])

export default __exports__